import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '@environments/environment';

import { MenuItem } from '../../shared/models/side-menu.model';
import { Observable } from 'rxjs';
import { FavoriteStatusPayload } from '../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  http = inject(HttpClient);

  urlProfileManagement = environment.urlProfileManagement;

  /**
   * Fetches the list of menu items that the user with the given email has access to.
   * @param email - The email of the user whose accessible menus are to be fetched.
   * @returns An Observable of an array of MenuItem objects representing the accessible menus.
   */
  getMenusWithAccess(email: string): Observable<MenuItem[]> {
    const encodedEmail = encodeURIComponent(email)
    return this.http.get<MenuItem[]>(`${this.urlProfileManagement}/api/v1/menus/${encodedEmail}`);
  }

  updateFavoriteStatus(favoriteItem: FavoriteStatusPayload): Observable<{result: boolean}> {
    return this.http.post<{result: boolean}>(`${this.urlProfileManagement}/api/v1/favorites`, favoriteItem);
  }
}
